module.exports = __webpack_public_path__ + "img/RE.24fd396f.svg";